import React, { useContext, useState } from 'react';
import api from '../api';
import { SelectedCompanyContext } from '../contexts/SelectedCompanyContext';
import { useNavigate, useParams } from 'react-router-dom';
import { getFallbackTemplates, useCompanyTaskTemplates } from '../hooks/queries/useTaskTemplates';

const OnboardingSelectSystems = () => {
  const { selected, setSelected } = useContext(SelectedCompanyContext);
  const { companyId } = useParams();
  const navigate = useNavigate();
  const { data: templatesData } = useCompanyTaskTemplates(companyId);

  const templates = (Array.isArray(templatesData) && templatesData.length > 0)
    ? templatesData
    : getFallbackTemplates();

  const systemOptions = templates
    .filter((t) => t.group === 'internalSystems' && t.isActive !== false)
    .sort((a, b) => (Number(a.sortOrder) || 0) - (Number(b.sortOrder) || 0))
    .map((t) => t.title);

  const [checked, setChecked] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const toggle = (sys) => {
    setChecked(prev => prev.includes(sys) ? prev.filter(s => s!==sys) : [...prev, sys]);
  };

  const handleSave = async () => {
    if (checked.length === 0) {
      alert('Select at least one system');
      return;
    }
    setSaving(true);
    try {
      // create tasks sequentially
      for (const type of checked) {
        await api.post(`/tasks/company/${companyId}`, { type, status: 'Not Started' });
      }
      // refetch tasks and update context
      const res = await api.get(`/tasks/company/${companyId}`);
      setSelected(prev => ({ ...prev, CompanyTasks: res.data }));
      navigate(`/onboarding/${companyId}`);
    } catch (err) {
      console.error(err);
      setError('Failed to save tasks');
    } finally {
      setSaving(false);
    }
  };

  if (!selected) return null;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Internal System Setup – Select Systems</h1>
      {error && <p className="text-red-500 mb-2">{error}</p>}
      <div className="mb-6">
        {systemOptions.map(sys => (
          <label key={sys} className="block mb-2">
            <input
              type="checkbox"
              className="mr-2"
              checked={checked.includes(sys)}
              onChange={() => toggle(sys)}
            />
            {sys}
          </label>
        ))}
      </div>
      <button onClick={handleSave} disabled={saving} className="bg-blue-500 text-white py-2 px-4 rounded">
        {saving ? 'Saving...' : 'Save & Continue'}
      </button>
    </div>
  );
};

export default OnboardingSelectSystems; 